import React from "react";

const MagicStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 17,
  height: 16,
  viewBox: "0 0 17 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.9 2.19995C10.9 4.40909 9.70912 6.39995 7.5 6.39995C9.70912 6.39995 10.9 8.39083 10.9 10.6C10.9 8.39083 12.0909 6.39995 14.3 6.39995C12.0909 6.39995 10.9 4.40909 10.9 2.19995Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.29995 8.6001C5.29995 9.92562 4.02543 11.2001 2.69995 11.2001C4.02543 11.2001 5.29995 12.4746 5.29995 13.8001C5.29995 12.4746 6.57447 11.2001 7.89995 11.2001C6.57447 11.2001 5.29995 9.92562 5.29995 8.6001Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(MagicStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;